import React from 'react'
import {connect} from 'react-redux'

const mapStateAsProps = state => ({
    accountInfo : state.projectInfo.accountInfo,
    showAccountInfo: state.projectInfo.showAccountInfo
})

class WhosAccount extends React.Component{


    render(){
        if ( !this.props.accountInfo || !this.props.showAccountInfo ) return null
        return (
            <div className="report-box" id="account-details">
                <div className="report-box-header">
                    PROJECT'S ACCOUNT INFO   (Sysadmin only)
                </div>
                <div className="report-box-text">
                    Account UUID: {this.props.accountInfo.uuid} <br/>
                    Account Name: {this.props.accountInfo.name} <br/>
                    Account Email: {this.props.accountInfo.email}
                </div>
            </div>
        )
    }
}

export default connect(mapStateAsProps)(WhosAccount)